var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamedFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.022 0c.548 0 1.014.193 1.4.578.385.386.578.852.578 1.4v12.044c0 .548-.193 1.014-.578 1.4a1.906 1.906 0 0 1-1.4.578H1.978a1.906 1.906 0 0 1-1.4-.578 1.906 1.906 0 0 1-.578-1.4V1.978C0 1.43.193.964.578.578A1.906 1.906 0 0 1 1.978 0h12.044zM13.5 1.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1zM12.53 3a.47.47 0 0 1 .332.8L9.25 7.413v5.118c0 .381-.43.6-.738.384L6.95 11.822a.469.469 0 0 1-.2-.384V7.412L3.138 3.8a.47.47 0 0 1 .331-.8z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamedFilter);
export default __webpack_public_path__ + "static/media/named-filter.fc78cf9df6e02723b13c532df4118213.svg";
export { ForwardRef as ReactComponent };